import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { SupportRepresentative } from "@shared/types/localTypes/supportRepresentative.ts";

export const useSupportRepresentativesStore = defineStore(
  "supportRepresentatives",
  () => {
    // State
    const _supportRepresentatives = ref<SupportRepresentative[]>([]);
    const _isLoading = ref<boolean>(true);

    // Getters
    const supportRepresentatives = computed(
      () => _supportRepresentatives.value,
    );
    const isLoading = computed(() => _isLoading.value);

    // Actions
    const setSupportRepresentatives = (
      representatives: SupportRepresentative[],
    ) => {
      _supportRepresentatives.value = representatives;
    };

    const clearSupportRepresentatives = () => {
      _supportRepresentatives.value = [];
      _isLoading.value = true;
    };

    const setIsLoading = (loading: boolean) => {
      _isLoading.value = loading;
    };

    return {
      supportRepresentatives,
      isLoading,
      setSupportRepresentatives,
      clearSupportRepresentatives,
      setIsLoading,
    };
  },
);
